import { call, put, takeLatest } from "redux-saga/effects";
import {
    getTrainingVideos as getTrainingVideosRequest,
    markTrainingVideoWatched,
} from "../../services/training-video/training-video.service";
import {
    getTrainingVideos,
    getTrainingVideosFailure,
    getTrainingVideosSuccess,
    markWatched,
    markWatchedFailure,
    markWatchedSuccess,
} from "../reducer/training-video";
import {
    ITrainingVideosResponse,
    MarkWatchedActionPayload,
} from "../types/training-video";

// httpClient's response interceptor returns response.data, so a `call` here
// resolves to the response BODY — already { data, meta } — not an AxiosResponse.
function* getTrainingVideosSaga() {
    try {
        const body: ITrainingVideosResponse = yield call(getTrainingVideosRequest);
        yield put(getTrainingVideosSuccess(body));
    } catch (error: any) {
        yield put(getTrainingVideosFailure({ forbidden: error?.response?.status === 403 }));
    }
}

function* markWatchedSaga(action: MarkWatchedActionPayload) {
    try {
        const body: ITrainingVideosResponse = yield call(markTrainingVideoWatched, action.payload);
        yield put(markWatchedSuccess(body));
    } catch (error: any) {
        yield put(markWatchedFailure({ forbidden: error?.response?.status === 403 }));
    }
}

export function* rootSaga() {
    yield takeLatest(getTrainingVideos.type, getTrainingVideosSaga);
    yield takeLatest(markWatched.type, markWatchedSaga);
}
